import React from 'react';
import { Alert, Button, Typography } from 'antd';
import { ReloadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ErrorDisplay = ({ 
  error, 
  onRetry, 
  showRetry = true, 
  title = "Error",
  className = "",
  size = "default" 
}) => {
  const getErrorMessage = (error) => {
    if (typeof error === 'string') return error;
    if (error?.message) return error.message;
    if (error?.response?.data?.message) return error.response.data.message;
    if (error?.response?.statusText) return error.response.statusText;
    return 'An unexpected error occurred';
  };

  const getErrorCode = (error) => {
    if (error?.response?.status) return error.response.status;
    if (error?.code) return error.code;
    return null;
  };

  const errorMessage = getErrorMessage(error);
  const errorCode = getErrorCode(error);

  return (
    <div className={`error-display ${className}`} role="alert">
      <Alert
        message={
          <div className="flex items-center gap-2">
            <ExclamationCircleOutlined />
            <span className="font-medium">{title}</span>
            {errorCode && (
              <Text type="secondary" className="text-xs">
                (Code: {errorCode})
              </Text>
            )}
          </div>
        }
        description={
          <div className="mt-2">
            <Text className="block mb-3">{errorMessage}</Text>
            {showRetry && onRetry && (
              <Button
                type="primary"
                size="small"
                icon={<ReloadOutlined />}
                onClick={onRetry}
                aria-label="Retry operation"
              >
                Try Again
              </Button>
            )}
          </div>
        }
        type="error"
        showIcon={false}
        className={size === 'small' ? 'text-sm' : ''}
      />
    </div>
  );
};

export default ErrorDisplay;
